import { isNativeRuntime } from "./platform";

/** App lock settings (per device, Capacitor Preferences). Default: on, after 1 minute in the background. */
export interface LockSettings { enabled: boolean; afterSeconds: number }
export const LOCK_DEFAULT: LockSettings = { enabled: true, afterSeconds: 60 };
export const LOCK_CHOICES = [0, 60, 300, 900];
const KEY = "spos.appLock";

export async function loadLock(): Promise<LockSettings> {
  if (!isNativeRuntime()) return { ...LOCK_DEFAULT, enabled: false };
  const { Preferences } = await import("@capacitor/preferences");
  try { const v = JSON.parse((await Preferences.get({ key: KEY })).value ?? "null"); if (v && typeof v.enabled === "boolean" && LOCK_CHOICES.includes(v.afterSeconds)) return v; } catch { /* default */ }
  return LOCK_DEFAULT;
}
export async function saveLock(s: LockSettings) {
  const { Preferences } = await import("@capacitor/preferences");
  await Preferences.set({ key: KEY, value: JSON.stringify(s) });
}

/** Pure decision used on resume (unit-tested). */
export function shouldLock(o: { settings: LockSettings; backgroundedAt: number | null; now: number; signedIn: boolean; deviceSecure: boolean }): boolean {
  if (!o.signedIn || !o.settings.enabled || !o.deviceSecure || o.backgroundedAt === null) return false;
  return o.now - o.backgroundedAt >= o.settings.afterSeconds * 1000;
}

export async function deviceSecurity(): Promise<{ secure: boolean; biometry: boolean }> {
  if (!isNativeRuntime()) return { secure: false, biometry: false };
  const { BiometricAuth } = await import("@aparajita/capacitor-biometric-auth");
  try { const r = await BiometricAuth.checkBiometry(); return { secure: r.deviceIsSecure || r.isAvailable, biometry: r.isAvailable }; } catch { return { secure: false, biometry: false }; }
}

/** Fingerprint / face, falling back to the device PIN/pattern/password. */
export async function authenticate(reason: string, cancel: string): Promise<boolean> {
  const { BiometricAuth } = await import("@aparajita/capacitor-biometric-auth");
  try {
    await BiometricAuth.authenticate({ reason, cancelTitle: cancel, allowDeviceCredential: true, iosFallbackTitle: "", androidTitle: reason, androidConfirmationRequired: false });
    return true;
  } catch { return false; }
}
